import styled from 'styled-components';
import React from 'react';
import { get } from '../constants.js';
import sx from '../sx.js';
import classes from './ButtonGroup.module.css.js';
import { toggleStyledComponent } from '../internal/utils/toggleStyledComponent.js';
import { clsx } from 'clsx';
import '../FeatureFlags/FeatureFlags.js';
import { useFeatureFlag } from '../FeatureFlags/useFeatureFlag.js';
import '../FeatureFlags/DefaultFeatureFlags.js';

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
const StyledButtonGroup = toggleStyledComponent('primer_react_css_modules_team', styled.div.withConfig({
  displayName: "ButtonGroup__StyledButtonGroup",
  componentId: "sc-1gxhls1-0"
})(["display:inline-flex;vertical-align:middle;isolation:isolate;&& > *:not([data-loading-wrapper]){margin-inline-end:-1px;position:relative;border-radius:0;:first-child{border-top-left-radius:", ";border-bottom-left-radius:", ";}:last-child{border-top-right-radius:", ";border-bottom-right-radius:", ";}:focus,:active,:hover{z-index:1;}}[data-loading-wrapper]{:first-child{button,a{border-top-left-radius:", ";border-bottom-left-radius:", ";}}:last-child{button,a{border-top-right-radius:", ";border-bottom-right-radius:", ";}}}[data-loading-wrapper] > *{margin-inline-end:-1px;position:relative;border-radius:0;:focus,:active,:hover{z-index:1;}}", ";"], get('radii.2'), get('radii.2'), get('radii.2'), get('radii.2'), get('radii.2'), get('radii.2'), get('radii.2'), get('radii.2'), sx));
const ButtonGroup = /*#__PURE__*/React.forwardRef(function ButtonGroup({
  children,
  className,
  ...rest
}, forwardRef) {
  const enabled = useFeatureFlag('primer_react_css_modules_team');
  return /*#__PURE__*/React.createElement(StyledButtonGroup, _extends({
    ref: forwardRef,
    className: clsx(className, {
      [classes.ButtonGroup]: enabled
    })
  }, rest), children);
});
ButtonGroup.displayName = 'ButtonGroup';

export { ButtonGroup as default };
